import { Component, OnInit } from '@angular/core';
import { PaginationArgs } from '../shared/models/pagination.args.model';
import { HomeService } from './services/home.service';
import { AcpAccountService } from '../acp-account/services/acp-account.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  events: any;
  paginationArgs: PaginationArgs = { pageNumber: 1, pageSize: 10 };
  orderBy = { order_by: 'startingDate', order_by_sorting: 'ASC' }
  sliders: any;
  assets: any;

  constructor(
    private homeService:HomeService,
    private acpAccountService: AcpAccountService) { 
  }

  ngOnInit(): void {
    this.homeService.getSlideHome().subscribe(res => { this.sliders = res.Data})
    this.homeService.eventsFilter(this.paginationArgs,{}, this.orderBy).subscribe(res => {
      this.events = res.Data;

      setTimeout(() => {
        HomeComponent.loadScript('/assets/js/init-swipper.js');
      }, 0);
    })
    this.getAssetsWidget();
  }

  static loadScript(url) {
    const node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    document.querySelector('body').appendChild(node);
  }

  getAssetsImageWidth(length: number): string {
    const widthMap = {
      1: '20%',
      2: '40%',
      3: '40%',
      4: '60%',
    };
  
    return widthMap[length] || '60%';
  }

  getAssetsShow(length: number){
    return Math.min(length || 0, 4)
  }

  getAssetsWidget() {
    this.acpAccountService.getAssets().subscribe((res) => {
      this.assets = res.Data;
    });
  }

}
